<li-navbar *ngIf="showNavbar"></li-navbar>

<div class="container">
  <router-outlet></router-outlet>
</div>
